<template>
    <div>
        <h6>{{ $t('Component(VerificationDocuments):label') }}</h6>
        <b-list-group>
            <b-list-group-item v-for="verificationDocument in verificationDocuments">
                {{ $t('Component(VerificationDocumentTypeEnum):' + verificationDocument) }}
                <div
                    v-if="'evidence' === verificationDocument && evidenceReportTypes.length > 0"
                    class="pt-50"
                >
                    <BBadge
                        v-for="type in evidenceReportTypes"
                        variant="primary"
                        class="mr-50"
                    >
                        {{ type.title }}
                    </BBadge>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import { BListGroup, BListGroupItem, BBadge } from 'bootstrap-vue'
export default {
    components: {
        BListGroup, BListGroupItem, BBadge
    },
    props: {
        verificationDocuments: {
            type: Array,
            default() {
                return [];
            }
        },
        evidenceReportTypes: {
            type: Array,
            default() {
                return [];
            }
        }
    }
}
</script>
